import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import moment from "moment";
import Api from "../../Api.js";
import SuccessToast from "../BlueButton/SuccessToast.js";
import ErrorToast from "../BlueButton/ErrorToast.js";
import {Col, Modal, Row} from "react-bootstrap";
import {
    FormControl,
    Select,
    InputLabel,
    ListItemText,
    MenuItem,
    OutlinedInput,
    TextField,
    Autocomplete
} from "@mui/material";
import {word} from "../../word.js";
import Loader from "../BlueButton/Loader.js";
import BlueButton from "../BlueButton/BlueButton.js";
import {surveyAddLocalRequest} from "../../store/actions/dayoff.js";
import qs from "query-string";

function AddAndEditSurvey({onHide, show,getData, isEdit = null,}) {
    const [submitted, setSubmitted] = useState(false)
    const [users,setUsers] = useState([]);
    const dispatch = useDispatch()
    const companies = useSelector((state) => state.task.companies);

    const [form, setForm] = useState({
        title: '',
        purpose: '',
        company_id:'',
        deadline: moment(new Date()).add(1, 'day').format("YYYY-MM-DDTHH:mm"),
        recipient_ids: [],
        status:'draft',
        file: []
    })
    const query = qs.parse(location.search, {arrayFormat: 'comma'});

    const account = useSelector((state) => state.task.accountant);
    const managers = useSelector((state) => state.task.managers);
    const handleChange = (name, val) => {
        setForm((prevState) => {
            if (name === 'deadline') {
                const newDeadline = moment(val);
                if (newDeadline.isBefore(moment())) {
                    return {
                        ...prevState,
                        deadline: moment(new Date()).format("YYYY-MM-DDTHH:mm")
                    }
                } else {
                    return {
                        ...prevState,
                        deadline: newDeadline.format("YYYY-MM-DDTHH:mm"),
                    }
                }
            }
            if(name === 'file') {
                let newFiles = Array.from(val.target.files);
                return {
                    ...prevState,
                    file: [...prevState.file,...newFiles]
                }
            }
            return {
                ...prevState,
                [name]: val
            }
        })
    }
    const deletePhoto = (index) => {
        setForm((prevState) => {
            const newFiles = [...prevState.file];
            newFiles.splice(index, 1);
            return {
                ...prevState,
                file: newFiles
            }
        });
    }
    const handleAdd = async () => {
        try {
            setSubmitted(true)
            const formData = new FormData()
            const formDataFile = new FormData()
            formData.append("title", form.title);
            formData.append("purpose",form.purpose);
            formData.append("deadline", form.deadline);
            formData.append("company_id", form.company_id);

            form.recipient_ids.forEach((id) => formData.append("recipient_ids", id));
            const files = form.file;

            let querystring = qs.stringify(query, {
                arrayFormat: 'comma',
                skipEmptyString: true,
            })

            if (isEdit){
                for (let i = 0; i < files.length; i++) {
                    formDataFile.append("file"+(i+1), files[i]);
                }
                if( files.length > 0){
                    await Api.createSurveyFile(isEdit.id, formDataFile)
                }
                await Api.updateSurvey(isEdit.id, formData)
                await getData()
            }else{
                for (let i = 0; i < files.length; i++) {
                    formData.append("file"+(i+1), files[i]);
                }
                await Api.createSurvey(formData)
            }
            const {data} = await Api.getSurvey(querystring)
            dispatch(surveyAddLocalRequest(data))
            SuccessToast()
            onHide()
        } catch (e) {
            console.log(e)
            ErrorToast()
        }
    }

    useEffect(() => {
        setUsers([...account.map((item) => ({id: item.user_id, name: `${item.user.first_name} ${item.user.last_name}`})),...managers.map((item) => ({id: item.user_id, name: `${item.user.first_name} ${item.user.last_name}`}))])
    },[account, managers])

    useEffect(() => {
        if(isEdit){
            setForm({
                title: isEdit.title,
                purpose: isEdit.purpose,
                deadline: moment(isEdit.deadline).format("YYYY-MM-DDTHH:mm"),
                company_id: isEdit.company.id,
                recipient_ids:isEdit.recipients.map((item => item.id)),
                file: [],
                status: isEdit.status
            })
        }
    },[isEdit])
    return (
        <Modal
            {...{onHide, show}}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header className='green-top'>
                <Modal.Title id="contained-modal-title-vcenter"
                             className="w-100 d-flex flex-row justify-content-between">
                    <span>Ավելացնել նոր Հարցում</span>
                    <div className="tool-tip-cont">
                        <div className="tool-tip">Փակել</div>
                        <i className="fas fa-times" onClick={onHide}/>
                    </div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className='container'>
                    <Row className="justify-content-center">
                        <Col xs={12} sm={10}>
                            <div
                                className={!form.title && submitted ? "input-validation input-validation-valid" : "input-validation"}>
                                <TextField
                                    name='title'
                                    value={form.title}
                                    onChange={(e) => handleChange('title', e.target.value)}
                                    label="Անվանում"
                                    multiline
                                    variant="outlined"
                                    error={!form.title && submitted}
                                    className={!form.title && submitted ? "validation-outlined-input" : "outlined-helperText"}
                                />
                                {!form.title && submitted &&
                                <div className="validation valid-center">{word['empty_error']}</div>}
                            </div>
                            <div
                                className={!form.purpose && submitted ? "input-validation input-validation-valid" : "input-validation"}>
                                <TextField
                                    name='text'
                                    value={form.purpose}
                                    onChange={(e) => handleChange('purpose', e.target.value)}
                                    label="Պատճառ"
                                    multiline
                                    variant="outlined"
                                    error={!form.purpose && submitted}
                                    className={!form.purpose && submitted ? "validation-outlined-input" : "outlined-helperText"}
                                />
                                {!form.purpose && submitted &&
                                <div className="validation valid-center">{word['empty_error']}</div>}
                            </div>
                            {!isEdit && (
                                <FormControl fullWidth style={{ marginBottom: 30 }}>
                                    <Autocomplete
                                        options={companies}
                                        getOptionLabel={(option) => option.name}
                                        value={companies.find((c) => c.id === form.company_id) || null}
                                        onChange={(event, newValue) => {
                                            handleChange('company_id', newValue ? newValue.id : null);
                                        }}
                                        renderInput={(params) => (
                                            <TextField {...params} label="Կազմակերպություն" variant="outlined" />
                                        )}
                                        isOptionEqualToValue={(option, value) => option.id === value.id}
                                    />
                                </FormControl>
                            )}
                            <FormControl fullWidth style={{ marginBottom: 30 }}>
                                <Autocomplete
                                    multiple
                                    options={users}
                                    getOptionLabel={(option) => option.name}
                                    value={users.filter((user) => form.recipient_ids.includes(user.id))}
                                    onChange={(event, newValue) => {
                                        handleChange('recipient_ids', newValue.map((user) => user.id));
                                    }}
                                    renderInput={(params) => (
                                        <TextField {...params} label="Աշխատակիցներ և մենեջերներ" placeholder="Ընտրել աշխատողներին" />
                                    )}
                                    isOptionEqualToValue={(option, value) => option.id === value.id}
                                />
                            </FormControl>
                            <div className='input-validation'>
                                <TextField
                                    id="datetime-local"
                                    value={form.deadline}
                                    label="Ժամանակացույց սկիզբ"
                                    type="datetime-local"
                                    onChange={(ev) => handleChange('deadline', ev.target.value)}
                                    variant="outlined"
                                    InputProps={{inputProps: {min: moment(new Date()).format("YYYY-MM-DDTHH:mm")}}}
                                    sx={{width: 250}}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </div>
                            <div className='img-icon-cont'>
                                <div className='img-cont'>
                                    {form.file.map((item, index) => {
                                        return <div className='img' key={index}>
                                                <span
                                                    className={(item.type === "image/jpeg") || (item.type === "image/png") ? 'icon-Photos' : "icon-files-empty"}/>
                                            <span className='images-name'>{item.name}</span>
                                            <i className="fas fa-times" onClick={() => deletePhoto(item)}/>
                                        </div>
                                    })}
                                </div>
                                <label>
                                    <span className='icon-Attachment'/>
                                    <input type="file" multiple className='input-icon'
                                           onChange={(e) => handleChange('file',e)}/>
                                </label>

                            </div>
                            <div className='line-blue'/>
                            {submitted ? <div className="disable-loader"><Loader size={30}/></div> : null}
                            <div className='button-line'>
                                <BlueButton disabled={submitted}
                                            title={isEdit?word.edit:word.create}
                                            buttonStyle={!submitted ? "blue-button" : "blue-button blue-button-disabled"}
                                            onChangeValue={() => handleAdd()}
                                />
                            </div>
                        </Col>
                    </Row>
                </div>
            </Modal.Body>
        </Modal>
    );
}


export default AddAndEditSurvey;